{
  "label": "grupo de usuario",
  "button": {
    "delete": "Eliminar el grupo",
    "create": "Nuevo grupo"
  },
  "confirmDelete": {
    "title": "Eliminación de un grupo",
    "description": "Se eliminará el grupo seleccionado \"{userGroupName}\""
  },
  "cannotDelete": {
    "title": "No se puede eliminar un grupo",
    "description": "El grupo seleccionado \"{userGroupName}\" está asociado a {usersCount} usuarios"
  },
  "empty": "No se ha encontrado ningún grupo",
  "search": "Búsqueda por nombre",
  "create": {
    "title": "Nuevo grupo",
    "confirm": {
      "title": "Creación de grupo"
    }
  },
  "update": {
    "title": "Modificar grupo",
    "confirm": {
      "title": "Editar el grupo"
    }
  },
  "confirm": {
    "message": "¿Confirma la cancelación de la operación? Se perderán todos los datos no guardados."
  },
  "information": "Información de grupo",
  "name": "Nombre de grupo",
  "sector": {
    "title": "Sectores"
  },
  "sectors": {
    "label": "Sectores añadidos al grupo"
  },
  "addUsers": {
    "title": "Añadir usuarios"
  }
}
